import { render, staticRenderFns } from "./WdfRedirectFromKagamiPage.vue?vue&type=template&id=427fc70b"
import script from "./WdfRedirectFromKagamiPage.vue?vue&type=script&lang=js"
export * from "./WdfRedirectFromKagamiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports